"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SchultzRhinestonePortalWeb = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var _operations = require("./operations");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var packageName = "portalApi";
var packageVersion = "1";

var SchultzRhinestonePortalWeb = /*#__PURE__*/function (_coreHttp$ServiceClie) {
  (0, _inherits2["default"])(SchultzRhinestonePortalWeb, _coreHttp$ServiceClie);

  var _super = _createSuper(SchultzRhinestonePortalWeb);

  /**
   * Initializes a new instance of the SchultzRhinestonePortalWeb class.
   * @param $host server parameter
   * @param options The parameter options
   */
  function SchultzRhinestonePortalWeb($host, options) {
    var _options$endpoint;

    var _this;

    (0, _classCallCheck2["default"])(this, SchultzRhinestonePortalWeb);

    if ($host === undefined) {
      throw new Error("'$host' cannot be null");
    } // Initializing default values for options


    if (!options) {
      options = {};
    }

    var defaultUserAgent = "azsdk-js-".concat(packageName.replace(/@.*\//, ""), "/").concat(packageVersion, " ").concat(coreHttp.getDefaultUserAgentValue());
    _this = _super.call(this, undefined, _objectSpread(_objectSpread({}, options), {}, {
      userAgent: options.userAgent ? "".concat(options.userAgent, " ").concat(defaultUserAgent) : "".concat(defaultUserAgent)
    }));
    _this.requestContentType = "application/json; charset=utf-8";
    _this.baseUri = (_options$endpoint = options.endpoint) !== null && _options$endpoint !== void 0 ? _options$endpoint : "{$host}"; // Parameter assignments

    _this.$host = $host;
    _this.account = new _operations.AccountImpl((0, _assertThisInitialized2["default"])(_this));
    _this.aiAssistant = new _operations.AiAssistantImpl((0, _assertThisInitialized2["default"])(_this));
    _this.annotation = new _operations.AnnotationImpl((0, _assertThisInitialized2["default"])(_this));
    _this.archive = new _operations.ArchiveImpl((0, _assertThisInitialized2["default"])(_this));
    _this.assetCollection = new _operations.AssetCollectionImpl((0, _assertThisInitialized2["default"])(_this));
    _this.assetCollectionItem = new _operations.AssetCollectionItemImpl((0, _assertThisInitialized2["default"])(_this));
    _this.assetCollectionRelease = new _operations.AssetCollectionReleaseImpl((0, _assertThisInitialized2["default"])(_this));
    _this.assetCollectionTemplate = new _operations.AssetCollectionTemplateImpl((0, _assertThisInitialized2["default"])(_this));
    _this.document = new _operations.DocumentImpl((0, _assertThisInitialized2["default"])(_this));
    _this.documentPdfPrint = new _operations.DocumentPdfPrintImpl((0, _assertThisInitialized2["default"])(_this));
    _this.documentAttachment = new _operations.DocumentAttachmentImpl((0, _assertThisInitialized2["default"])(_this));
    _this.documentFamily = new _operations.DocumentFamilyImpl((0, _assertThisInitialized2["default"])(_this));
    _this.documentRelation = new _operations.DocumentRelationImpl((0, _assertThisInitialized2["default"])(_this));
    _this.documentRelationGroup = new _operations.DocumentRelationGroupImpl((0, _assertThisInitialized2["default"])(_this));
    _this.documentSection = new _operations.DocumentSectionImpl((0, _assertThisInitialized2["default"])(_this));
    _this.documentSubscriptions = new _operations.DocumentSubscriptionsImpl((0, _assertThisInitialized2["default"])(_this));
    _this.documentVersion = new _operations.DocumentVersionImpl((0, _assertThisInitialized2["default"])(_this));
    _this.documentVersionSubscription = new _operations.DocumentVersionSubscriptionImpl((0, _assertThisInitialized2["default"])(_this));
    _this.documentView = new _operations.DocumentViewImpl((0, _assertThisInitialized2["default"])(_this));
    _this.email = new _operations.EmailImpl((0, _assertThisInitialized2["default"])(_this));
    _this.featureFlag = new _operations.FeatureFlagImpl((0, _assertThisInitialized2["default"])(_this));
    _this.legalAttributes = new _operations.LegalAttributesImpl((0, _assertThisInitialized2["default"])(_this));
    _this.legalStatus = new _operations.LegalStatusImpl((0, _assertThisInitialized2["default"])(_this));
    _this.localizations = new _operations.LocalizationsImpl((0, _assertThisInitialized2["default"])(_this));
    _this.mainPageTiles = new _operations.MainPageTilesImpl((0, _assertThisInitialized2["default"])(_this));
    _this.mergeDocument = new _operations.MergeDocumentImpl((0, _assertThisInitialized2["default"])(_this));
    _this.pageConfigurations = new _operations.PageConfigurationsImpl((0, _assertThisInitialized2["default"])(_this));
    _this.paragraphZoom = new _operations.ParagraphZoomImpl((0, _assertThisInitialized2["default"])(_this));
    _this.portal = new _operations.PortalImpl((0, _assertThisInitialized2["default"])(_this));
    _this.portalAsset = new _operations.PortalAssetImpl((0, _assertThisInitialized2["default"])(_this));
    _this.product = new _operations.ProductImpl((0, _assertThisInitialized2["default"])(_this));
    _this.productPage = new _operations.ProductPageImpl((0, _assertThisInitialized2["default"])(_this));
    _this.profile = new _operations.ProfileImpl((0, _assertThisInitialized2["default"])(_this));
    _this.search = new _operations.SearchImpl((0, _assertThisInitialized2["default"])(_this));
    _this.searchPreview = new _operations.SearchPreviewImpl((0, _assertThisInitialized2["default"])(_this));
    _this.searchSubscription = new _operations.SearchSubscriptionImpl((0, _assertThisInitialized2["default"])(_this));
    _this.searchSuggestionsProvider = new _operations.SearchSuggestionsProviderImpl((0, _assertThisInitialized2["default"])(_this));
    _this.spaBootstrap = new _operations.SpaBootstrapImpl((0, _assertThisInitialized2["default"])(_this));
    _this.taxonomyOperations = new _operations.TaxonomyOperationsImpl((0, _assertThisInitialized2["default"])(_this));
    _this.ticket = new _operations.TicketImpl((0, _assertThisInitialized2["default"])(_this));
    _this.timeline = new _operations.TimelineImpl((0, _assertThisInitialized2["default"])(_this));
    _this.translations = new _operations.TranslationsImpl((0, _assertThisInitialized2["default"])(_this));
    _this.user = new _operations.UserImpl((0, _assertThisInitialized2["default"])(_this));
    _this.userProfile = new _operations.UserProfileImpl((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  return SchultzRhinestonePortalWeb;
}(coreHttp.ServiceClient);

exports.SchultzRhinestonePortalWeb = SchultzRhinestonePortalWeb;